<template>
  <div class="nav-bar" :style="'background: linear-gradient(to right, rgba(5, 140, 253, ' + s + '), rgba(73, 220, 252,' + s + '), 60%, rgba(64, 138, 249,' + s +'))'">
    <div class="nav-bar-c">
      <div class="nav-bar-c-left">
          <img src="../static/image/611617353325.jpg" alt="">
          <!-- <img src="../static/image/571617348698.jpg" alt=""> -->
      </div>
      <div class="nav-bar-c-right">
        <!-- <div class="nav-bar-c-right-item" v-for="(item,index) in menus" :key="index">
            {{item.name}}
        </div> -->
        <div class="nav-bar-c-right-item" >
            首页
        </div>
         <div class="nav-bar-c-right-item" >
            <a :href="loginUrl" target="_blank">登录</a>
        </div>
        <div class="nav-bar-c-right-item" >
            客服热线 400 629 8107
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "HelloWorld",
  data() {
    return {
      loginUrl: process.env.VUE_APP_LOGIN_URL
    }
    
  },
  props: {
    // menus: Array,
    s: Number
  },
};
</script>
<style scoped>
.nav-bar{
    width: 100%;
    height: 60px;
    position: fixed;
    top: 0;
    z-index: 99;
    padding: 10px 0;
    /* border-bottom: 1px solid #fff; */
    /* background: linear-gradient(to right, rgba(5, 140, 253, 1.000), rgba(73, 220, 252, 1.000), 60%, rgba(64, 138, 249, 1.000)); */
}
.nav-bar-c{
    margin: 0 auto;
    width: 1100px;
    display: flex;
    height: 100%;
    justify-content: space-between;
}
.nav-bar-c-left{
    height: 100%;
}
.nav-bar-c-left>img{
    height: 100%;
}
.nav-bar-c-right{
    display: flex;
    align-items: center;
}
.nav-bar-c-right-item{
    margin: 0 30px;
    color: #fff;
    font-size: 18px;
    cursor: pointer;
    transition: all .5s;
    /* text-shadow: 0px 5px 5px #aaa; */
}
.nav-bar-c-right-item a{
  color: #fff;
  transition: all .5s;
}
.nav-bar-c-right-item:hover{
    color: rgb(5, 140, 253);
}
.nav-bar-c-right-item a:hover{
   color: rgb(5, 140, 253);
}
</style>